// extracted by mini-css-extract-plugin
export default {"page":"CompareScenariosPage_page__RagwY"};